import loaderAnimation from '@/assets/lottie/main_loader.json'
import Lottie from 'lottie-react'
import { useEffect, useRef } from 'react'
import { CircleLoader } from '@/components/loader/CircleLoader.jsx'


export const MainLoader = ({ className }) => {

    // const lottieRef = useRef()

    // useEffect(() => {
    //     if (lottieRef.current) {
    //         lottieRef.current.setSpeed(2); // Adjust speed multiplier here
    //     }
    // }, []);

    return (
        <div className={`w-full flex justify-center items-center h-screen ${className}`}>
            <CircleLoader />
            {/*<Lottie*/}
            {/*    style={{ maxWidth: "250px" }}*/}
            {/*    animationData={loaderAnimation}*/}
            {/*    lottieRef={lottieRef}*/}
            {/*/>*/}
        </div>
    )
}
